import { FC } from 'react'
import { Button, ButtonProps, Icon } from '@/ui'
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
const UploadBackButton: FC<ButtonProps> = (props) => (
  <Button {...props} variant="link" className="flex items-center">
    <Icon icon={faArrowLeft} />
    Back
  </Button>
)

export { UploadBackButton }
